var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsNumber } from 'class-validator';
export class OfficeLocationStatsDto {
    exerciseProgramCount;
    startedExerciseProgramCount;
    trainingSessionCount;
    videoCallCount;
    startedVideoCallCount;
    patientCount;
    onboardedPatientCount;
    diagnosesCount;
    therapistCount;
    onboardedTherapistCount;
    score;
}
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "exerciseProgramCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "startedExerciseProgramCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "trainingSessionCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "videoCallCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "startedVideoCallCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "patientCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "onboardedPatientCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "diagnosesCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "therapistCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "onboardedTherapistCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationStatsDto.prototype, "score", void 0);
//# sourceMappingURL=office-location-stats.dto.js.map